import { trpc } from "../trpc";

export const useSearchInterfaceCollaborators = ({
  id,
  search,
}: {
  id: string;
  search: string;
}) => {
  const { data, isLoading, isFetching } =
    trpc.interface.searchCollaborators.useQuery(
      { id, search },
      { enabled: !!id },
    );

  return {
    collaborators: data?.members || [],
    isLoading,
    isFetching,
  };
};
